module.exports = __webpack_public_path__ + "assets/img/swiper-2.3452a924.jpg";